<div appDialogOverlay class="picker">
  <button appUiBackdropButton class="absolute inset-0" type="button" aria-label="Cancelar" (click)="close()"></button>
  <section appDialog class="picker__card relative z-10" aria-labelledby="assignee-picker-title" [ngpDialogModal]="true">
    <div class="picker__header">
      <h2 appDialogTitle id="assignee-picker-title" class="picker__title">Atribuir conversa</h2>
      <button appButton variant="ghost" size="sm" type="button" (click)="close()">Cancelar</button>
    </div>

    <input
      appInput
      type="search"
      placeholder="Buscar membro, equipe ou agente"
      (input)="setQuery($any($event.target).value)"
    />

    <div class="picker__scroll">
      @if (canAssumeSelf()) {
        <button
          *appIfPermission="'conversations:routing:assign'"
          appButton
          type="button"
          variant="secondary"
          size="sm"
          class="w-full justify-start"
          (click)="assumeSelf()"
        >
          Atribuir a mim
        </button>
      }

      <section class="picker__section" *appIfPermission="'conversations:routing:agent'">
        <h3 appUiLabel class="mb-1 uppercase">Agente</h3>
        <button type="button" appMenuItem (click)="toAgent()">
          {{ isAssignedToAgent() ? 'Gerar resposta do agente' : 'Atribuir ao agente do canal' }}
        </button>
      </section>

      @if (filteredMembers().length > 0) {
        <section class="picker__section" *appIfPermission="'conversations:routing:assign'">
          <h3 appUiLabel class="mb-1 uppercase">Membros</h3>
          @for (member of filteredMembers(); track member.id) {
            <button type="button" appMenuItem (click)="toMember(member)">{{ member.name }}</button>
          }
        </section>
      }

      @if (filteredTeams().length > 0) {
        <section class="picker__section" *appIfPermission="'conversations:routing:assign'">
          <h3 appUiLabel class="mb-1 uppercase">Equipes</h3>
          @for (team of filteredTeams(); track team.id) {
            <button type="button" appMenuItem (click)="toTeam(team)">{{ team.name }}</button>
          }
        </section>
      }

      @if (hasAssignee()) {
        <button
          *appIfPermission="'conversations:routing:assign'"
          appButton
          type="button"
          variant="danger"
          size="sm"
          class="w-full justify-start"
          (click)="unassign()"
        >
          Remover atribuição
        </button>
      }
    </div>
  </section>
</div>
